import { defineStore } from 'pinia'
import { useApi } from '~/composables/useApi'

export const useDestinationsStore = defineStore('destinations', {
  state: () => ({
    destinations: {
      loading: false,
      data: [],
    },

    destination: {
      loading: false,
      data: {},
    },
  }),

  actions: {
    async loadDestinations (params = {}) {
      this.destinations.loading = true
      try {
        const resp = await useApi('destinations.json', {
          query: {
            limit: 5000,
            show_quotes: true,
            ...params,
          },
        })
        this.destinations.data = resp.response.destinations || []
        return this.destinations.data
      } finally {
        this.destinations.loading = false
      }
    },

    async loadDestination (permalink) {
      this.destination.loading = true
      try {
        const resp = await useApi('destinations.json', {
          query: {
            permalink,
          },
        })
        this.destination.data = resp.response.destinations[0] || {}
      } finally {
        this.destination.loading = false
      }
    },
  },
})
